import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-review-completed',
  templateUrl: './admin-review-completed.component.html',
  styleUrls: ['./admin-review-completed.component.scss']
})
export class AdminReviewCompletedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
